export function transformOnlyDefinedValues<TBusinessObject, TTransformedBusinessObject>(
    dataTransformer: (data: TBusinessObject) => TTransformedBusinessObject,
): (data?: TBusinessObject) => TTransformedBusinessObject | undefined {
    return (data?: TBusinessObject): TTransformedBusinessObject | undefined =>
        data !== undefined ? dataTransformer(data) : undefined;
}
